import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
  placeObj: {
    place: [], //城市列表一级
    place_sub: {} //城市列表二级
  },
  tradeObj: {
    trade: [], //领域列表一级
    trade_sub: [], //领域列表二级
  },
  targetObj: {
    gb_hy: [], //行业分类（需求领域）
    cooperation_type: [], //合作方式
  },
  talentArr: [], //人才列表
  targetArr: [], //需求类型列表
	userInfo:{}, //用户信息
  userDigest:{}, //用户等级/限量等概况
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js